/* eslint-disable no-const-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable dot-notation */
/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable comma-spacing */
/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Table, Form, Modal, Spin, notification, Tooltip, Typography, Input, Button } from 'antd';
import { Button as CrcButton } from '@crc-evans/ui-components';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  HeatMapOutlined,
} from '@ant-design/icons';
import AddNewDocControlUser from './AddNewDocControlUser';
import { GetTableConfig, DeleteDetails } from '../../redux/calibration/saga';
import { fetchDocControlList } from '../../redux/calibration/action';
import '../../pages/technical/HeatProfilePage.css';

const { Title, Text } = Typography;

const DocControlMangement = (props) => {
  const { docControlData, isDocCOntrolLoading, onFetchDocList } = props;

  const [isEdit, setIsEdit] = useState(false);
  const [editRecord, seteditRecord] = useState('');
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [userForm] = Form.useForm();
  const [totalUsers, setTotalUsers] = useState(0);
  const [userModalVisible, setUserModalVisible] = useState(false);

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'ID',
      key: 'ID',
      align: 'center',
      width: 80,
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'UserName',
      key: 'UserName',
      align: 'left',
      width: 250,
      sorter: (a, b) => (a.UserName || '').localeCompare(b.UserName || ''),
    },
    {
      title: 'Location',
      dataIndex: 'Location',
      key: 'Location',
      align: 'left',
      width: 200,
      sorter: (a, b) => (a.Location || '').localeCompare(b.Location || ''),
    },
    {
      title: 'Document Type',
      dataIndex: 'documentType',
      key: 'documentType',
      align: 'left',
      width: 180,
      sorter: (a, b) => (a.documentType || '').localeCompare(b.documentType || ''),
    },
    {
      title: 'Email',
      dataIndex: 'Email',
      key: 'Email',
      align: 'left',
      width: 300,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      align: 'center',
      render: (record) => {
        if (record) {
          return (
            <div className="heat-profile-actions-cell">
              <Tooltip title="Edit">
                <EditOutlined
                  className="txtIcon"
                  onClick={() => onUpdateClick(record)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteOutlined
                  className="txtIcon"
                  onClick={() => showDeleteModal(record)}
                />
              </Tooltip>
            </div>
          );
        } else {
          return <div>-</div>;
        }
      },
    },
  ];

  useEffect(() => {
    (async () => {
      if (userData.length == 0) await fetchData();
    })();
  }, []);

  const fetchData = async () => {
    setShowLoader(true);
    const res = await GetTableConfig('UserManagement_DocControl');
    if (res && res.length > 0) {
      // Remove duplicates based on the Location property
      const uniqueLocations = res.filter(
        (item, index, self) => self.findIndex((obj) => obj.Location === item.Location) === index
      );
      res.map((item, i) => {
        item.sno = i + 1;
      });
      setUserData(res);
      setUniqueLocations(uniqueLocations);
    }
    setShowLoader(false);
  };

  const showAddUserModal = async () => {
    setUserModalVisible(true);
  };

  /** Deleting Spare parts data on confirm */
  const handleDeleteOk = async () => {
    {
      setIsDeleteLoading(true);
      const obj = {
        columnName: 'UserManagement_DocControl',
        tableName: 'UserManagement_DocControl',
        data: selectedData,
      };
      await DeleteDetails(obj);

      setSelectedData('');
      await fetchData();
      setIsDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  /** Display Confirmation while deleting */
  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };

  /** Cancelling the deletion of spare parts data */
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  const onUpdateClick = (record) => {
    setIsEdit(true);
    seteditRecord(record);
    setUserModalVisible(true);
  };

  return (
    <div className="heat-profile-content-wrapper">
      <div className="heat-profile-card">
        {/* Header - matches HeatProfile layout */}
        <div className="heat-profile-list-header">
          <div className="heat-profile-header-left">
            <div className="heat-profile-icon-wrap">
              <HeatMapOutlined style={{ fontSize: 22 }} />
            </div>
            <div className="heat-profile-header-content">
              <div className="heat-profile-title-row">
                <h3 className="heat-profile-list-title">
                  List of Calibration & Control Users
                </h3>
                <span className="heat-profile-summary">
                  {userData.length} item{userData.length !== 1 ? 's' : ''}
                </span>
              </div>
              <p className="heat-profile-list-description">
                Manage users for calibration and document control access.
              </p>
            </div>
          </div>
          <div className="heat-profile-header-actions">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => showAddUserModal()}
              className="heat-profile-add-btn"
            >
              Add New
            </Button>
          </div>
        </div>

        {/* Table - matches HeatProfile layout */}
        <div className="addTeamDetails heat-profile-table-wrap">
          <Table
            columns={columns}
            dataSource={userData}
            className="h-100 pipeline-table equipPaginationTable heat-profile-table"
            scroll={{ x: 1100, y: 'calc(100vh - 280px)' }}
            loading={showLoader}
            rowKey={(record) => record.ID || record.sno}
            pagination={
              userData.length > 10
                ? {
                  position: ['bottomRight'],
                  showSizeChanger: true,
                  className: 'heat-profile-pagination',
                  defaultPageSize: 10,
                }
                : false
            }
          />
        </div>
      </div>

      {userModalVisible && (
        <AddNewDocControlUser
          userModalVisible={userModalVisible}
          setUserModalVisible={setUserModalVisible}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          editRecord={editRecord}
          fetchData={fetchData}
          uniqueLocations={uniqueLocations}
          setUniqueLocations={setUniqueLocations}
        ></AddNewDocControlUser>
      )}

      <Modal
        width="45vw"
        className="heatprofile-modal"
        title="Delete Details"
        centered
        visible={isDeleteModalVisible}
        onCancel={handleDeleteCancel}
        footer={[
          <Button key="cancel" onClick={handleDeleteCancel}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleDeleteOk}
            loading={isDeleteLoading}
          >
            {isDeleteLoading ? 'Deleting...' : 'Delete'}
          </Button>,
        ]}
      >
        <div style={{ padding: '24px 0', fontSize: '16px', color: '#1B1516' }}>
          <p>Deleting all the corresponding and related information.</p>
          Are you sure you want to delete?
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ calibrationReducer }) => {
  const docControlData = get(calibrationReducer, 'docControlData', []);
  const isDocCOntrolLoading = get(calibrationReducer, 'isDocCOntrolLoading', false);

  return {
    docControlData,
    isDocCOntrolLoading,
  };
};

const mapDispatchToProps = {
  onFetchDocList: fetchDocControlList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocControlMangement);
